import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { ApiConstantsService } from './api-constants.service';
import { Pagination } from '~backoffice/app/~shared/models/core.models';
import {
  TaxType,
  TaxTypeCreationParams,
  TaxTypeListParams
} from '~core/models/tax-type.models';

@Injectable()
export class TaxTypeService {
  private _http = inject(HttpClient);
  private _apiConstantsService = inject(ApiConstantsService);

  list(
    params?: TaxTypeListParams & {
      [key: string]: any;
    }
  ): Observable<Pagination<TaxType>> {
    return this._http.get<Pagination<TaxType>>(
      this._apiConstantsService.taxTypesUrl,
      {
        params: {
          ...params,
          sort: params?.sort || 'createdAt',
          desc: params?.desc || 'createdAt'
        } as Record<string, any>
      }
    );
  }

  read(id: string): Observable<TaxType> {
    return this._http.get<TaxType>(
      `${this._apiConstantsService.taxTypesUrl}/${id}`
    );
  }

  create(payload: TaxTypeCreationParams): Observable<TaxType> {
    return this._http.post<TaxType>(this._apiConstantsService.taxTypesUrl, {
      ...payload,
      useStateFormViolationHandler: true
    });
  }

  update(
    id: string,
    payload: Partial<TaxTypeCreationParams>
  ): Observable<TaxType> {
    return this._http.put<TaxType>(
      `${this._apiConstantsService.taxTypesUrl}/${id}`,
      { ...payload, useStateFormViolationHandler: true }
    );
  }

  delete(id: string): Observable<unknown> {
    return this._http.delete(`${this._apiConstantsService.taxTypesUrl}/${id}`);
  }
}
